import Repository from '@/repositories/base/Repository';

export default class CnabRemittanceGeneratedRepository extends Repository {
  public async getDateFilterWhereExistsRemittances(): Promise<string | null> {
    const { data: response } = await this.datasource.get('cnabremittancegenerated/date-params');

    return response.data.max_date;
  }
}
